import React from 'react';
import { Button } from './Button';
export interface Coach {
  id: string;
  name: string;
  role: string;
  credentials: string;
  bio: string;
  fullBio: string;
  achievements: string[];
  philosophy: string;
  image?: string;
}
interface CoachCardProps {
  coach: Coach;
  index: number;
  onViewProfile: (coach: Coach) => void;
}
export function CoachCard({
  coach,
  onViewProfile
}: CoachCardProps) {
  const initials = coach.name.split(' ').map(n => n[0]).join('');
  return <div data-component="COMP-06-CoachCard" className="bg-white rounded-2xl overflow-hidden border border-navy-100 flex flex-col" data-id="element-40">
      <div className="p-8 flex-1 flex flex-col items-center text-center" data-id="element-41">
        {coach.image ? <img src={coach.image} alt={coach.name} className="w-28 h-28 rounded-full object-cover border-2 border-navy-200 mb-5" data-id="element-42" /> : <div className="w-28 h-28 rounded-full bg-navy-100 border-2 border-navy-200 flex items-center justify-center mb-5" data-id="element-43">
            <span className="text-2xl font-display font-bold text-navy-400" data-id="element-44">
              {initials}
            </span>
          </div>}

        <h3 className="text-xl font-bold text-navy-900 mb-1" data-id="element-45">{coach.name}</h3>
        <p className="text-brand-blue font-medium text-sm mb-1" data-id="element-46">
          {coach.credentials}
        </p>
        <p className="text-navy-500 text-sm font-medium mb-4" data-id="element-47">{coach.role}</p>

        <p className="text-navy-600 text-sm mb-6 flex-1 leading-relaxed" data-id="element-48">
          {coach.bio}
        </p>

        <Button variant="secondary" className="w-full" onClick={() => onViewProfile(coach)} aria-label={`View profile of ${coach.name}`} data-id="element-49">
          View Profile
        </Button>
      </div>
    </div>;
}